// extracted by mini-css-extract-plugin
export default {"container":"styles_container__x5Sec","clear":"styles_clear__ynkkP"};